var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-menu-main-div"},_vm._l((this.menuList),function(item){return _c('div',{class:item.selected ? 'select-item-bg' : 'normal-item-bg',on:{"click":function($event){return _vm.menuItemClick(item)}}},[_c('p',{class:item.selected ? 'select-item-title' : 'normal-item-title'},[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b242ec22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/live/LeftMenu.vue
// module id = null
// module chunks = 